import { getRouterSelectors } from '@ngrx/router-store'
import { createSelector } from '@ngrx/store'
import { selectCoreState } from '../reducers'

export const {
  selectCurrentRoute: getCurrentRoute, // select the current route
  selectFragment, // select the current route fragment
  selectQueryParams: getQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData: getRouteData, // select the current route data
  selectRouteDataParam, // factory function to select a route data param
  selectUrl, // select the current url
  selectTitle, // select the title if available
} = getRouterSelectors()

export const selectCurrentRoute = createSelector(selectCoreState, getCurrentRoute)
export const selectRouteData = createSelector(selectCoreState, getRouteData)
export const selectQueryParams = createSelector(selectCoreState, getQueryParams)
